import { LogicalKeyboardKey } from "./LogicalKeyboardKey";
import { RawKeyEvent } from "./RawKeyEvent";

export class RawKeyDownEvent extends RawKeyEvent {
  logicalKey: LogicalKeyboardKey;
  //TODO
}
